import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { withSize } from 'react-sizeme';
import _ from 'underscore';
import { textinputs } from 'seal-ui-components';
import store from '@Store';
import mixpanelEvents from '@Mixpanel';
import { MIX_PANEL } from '@Constants/types';
import { handleTextForSearch } from '@Utils/parsingUtils';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import ExpandablePanel from '@Components/UI/ExpandablePanel/ExpandablePanel';
import { NotFoundContainer } from './ClauseTree.style';

const SearchInput = React.memo(({ highlightClauses, showNoResultsMsg }) => {
    const [text, setText] = useState('');
    let debouncedHighlight = _.debounce(highlightClauses, 500);

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            highlightClauses(text);
        }
    };

    return (
        <div style={{ minHeight: '40px' }}>
            <textinputs.Search
                placeholder="Type to filter"
                value={text}
                onChange={e => {
                    setText(e.target.value);
                    debouncedHighlight(e.currentTarget.value);
                }}
                onKeyDown={handleKeyDown}
                data-testid="clauses_search_field"
            />
            {showNoResultsMsg && <NotFoundContainer>No matching results</NotFoundContainer>}
        </div>
    );
});

const ClauseTreeSearch = ({ setSearchResults, noExpandable }) => {
    const idx = useSelector(state => state.clause.idx);
    // const isIndexing = useSelector(state => state.clause.isIndexing);
    // const indexingErr = useSelector(state => state.clause.indexingErr);

    const [showNoResultsMsg, setShowNoResultsMsg] = useState(false);

    const highlightClauses = searchText => {
        if (searchText === '') {
            setSearchResults([]);
            setShowNoResultsMsg(false);
            return;
        }

        const manipulatedText = handleTextForSearch(searchText);

        let searchResults = [];

        try {
            searchResults = manipulatedText ? idx.search(manipulatedText).map(x => x.ref) : [];
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'FullMatchSearch', err);
        }

        if (searchText && searchText.length > 0 && searchResults && searchResults.length > 0) {
            setShowNoResultsMsg(false);
        } else {
            setShowNoResultsMsg(true);
        }

        setSearchResults(searchResults);

        const mixpanel = { numberClauseGroupsAfterFilter: searchResults.length };
        store.dispatch({ type: MIX_PANEL.MIXPANEL_DATA_CLAUSE_LIBRARY, payload: mixpanel });
        mixpanelEvents.clauseLibraryFilterApplied();
    };

    if (noExpandable) {
        return (
            <SearchInput highlightClauses={highlightClauses} showNoResultsMsg={showNoResultsMsg} />
        );
    }

    return (
        <ExpandablePanel
            controlledPanelCheck={true}
            title="Filter Clause Library"
            testid="clauses_filter_menu_arrow_button"
        >
            <SearchInput highlightClauses={highlightClauses} showNoResultsMsg={showNoResultsMsg} />
        </ExpandablePanel>
    );
};

export default withSize({ monitorHeight: true })(memo(ClauseTreeSearch));
